import { AlertCircle, CheckCircle, Info, XCircle } from "lucide-react";
import React from "react";

import { IgTypography } from "@intelligems/ig-theme/IgTypography";
import { useTheme } from "@mui/material";
import Grid from "@mui/material/Grid";

interface SystemMessageProps {
  content: string;
  type?: "info" | "success" | "error" | "warning";
  timestamp?: string;
}

export const SystemMessage: React.FC<SystemMessageProps> = ({
  content,
  type = "info",
  timestamp,
}) => {
  const theme = useTheme();

  const getIcon = () => {
    switch (type) {
      case "success":
        return <CheckCircle size={16} />;
      case "error":
        return <XCircle size={16} />;
      case "warning":
        return <AlertCircle size={16} />;
      default:
        return <Info size={16} />;
    }
  };

  const getColor = () => {
    switch (type) {
      case "success":
        return theme.palette.success.main;
      case "error":
        return theme.palette.error.main;
      case "warning":
        return theme.palette.warning.main;
      default:
        return theme.palette.info.main;
    }
  };
  const getBorderColor = () => {
    switch (type) {
      case "success":
        return theme.igBorders.success.default;
      case "error":
        return theme.igBorders.error.default;
      case "warning":
        return theme.igBorders.warning.default;
      default:
        return theme.igBorders.info.default;
    }
  };

  const getBackgroundColor = () => {
    switch (type) {
      case "success":
        return theme.igBackgroundColors.tonal.success;
      case "error":
        return theme.igBackgroundColors.tonal.error;
      case "warning":
        return theme.igBackgroundColors.tonal.warning;
      case "info":
      default:
        return theme.igBackgroundColors.tonal.info;
    }
  };

  return (
    <Grid
      container
      direction={"column"}
      justifyContent={"center"}
      rowSpacing={0}
    >
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        flexWrap={"nowrap"}
        // columnSpacing={1}
        sx={{
          backgroundColor: getBackgroundColor(),
          borderRadius: "8px",
          padding: "8px 16px",
          border: `1px solid ${getBorderColor()}`,
        }}
      >
        <Grid sx={{ color: getColor(), mt: 1 }}>{getIcon()}</Grid>
        <Grid mb={0.5} ml={1}>
          <IgTypography
            variant="body2"
            sx={{
              color: theme.palette.text.secondary,
              textAlign: "center",
            }}
          >
            {content}
          </IgTypography>
        </Grid>
      </Grid>
      {timestamp && (
        <Grid>
          <IgTypography
            variant="caption"
            sx={{
              color: theme.palette.text.tertiary,
              mt: 0.5,
              display: "block",
              textAlign: "center",
            }}
          >
            {timestamp}
          </IgTypography>
        </Grid>
      )}
    </Grid>
  );
};
